import styles from "./index.module.css";
import { animated } from "@react-spring/web";
import { useEffect } from "react";

const MovieList = ({
  movieData,
  currentIndexDelay,
  lastIndexDelay,
  handleCurrentIndexChange,
  handleIndexChange,
  posterStyles,
  movieListStyle,
  isMobile,
  index,
  handleNextIndex
}) => {
  return (
    <>
      {isMobile ? (
        <animated.div
          className={`${styles.ctn} movie-list-ctn`}
          style={{
            zIndex: movieData.length + 2,
            ...movieListStyle,
          }}
        >
          {posterStyles.map(({ x, display, scale, dashoffset, listX }, i) => {
            return (
              <animated.div className={styles.item}>
                <div>
                  <div
                    className={styles.name}
                    data-cursor-magnetic
                    data-cursor-size="80px"
                  >
                    {movieData[i].name}
                  </div>
                  <div className={styles.author}>{movieData[i].author}</div>
                </div>

                <div className={styles.lineBox}>
                  <div
                    className={`${styles.line} movie-list-line`}
                    onAnimationEnd={handleNextIndex}
                  ></div>
                </div>
              </animated.div>
            );
          })}
        </animated.div>
      ) : (
        <animated.div
          className={`${styles.ctn}  movie-list-ctn`}
          style={{
            zIndex: movieData.length + 2,
            ...movieListStyle,
          }}
        >
          {movieData.map((item, i) => {
            return (
              <div
                className={styles.item}
                onClick={() => {
                  handleIndexChange(i);
                }}
              >
                <div>
                  <div
                    className={styles.name}
                    data-cursor-magnetic
                    data-cursor-size="80px"
                  >
                    {item.name}
                  </div>
                  <div className={styles.author}>{item.author}</div>
                </div>

                <div className={styles.lineBox}>
                  <div
                    className={`${styles.line} movie-list-line`}
                    onAnimationEnd={() => {
                      console.log('end')
                      handleNextIndex()
                    }}
                  ></div>
                </div>
              </div>
            );
          })}
        </animated.div>
      )}
    </>
  );
};

export default MovieList;
